import React from 'react';
import useRefState from './useRefState';

const useLoading = (
    defaultValue?: boolean
): [boolean, (v: boolean) => void, React.RefObject<boolean>] => {
    return useRefState(!!defaultValue);
};

export default useLoading;
